module.exports = __webpack_public_path__ + "media/badges/updated-new-badge-1a4034fd.svg";